export default __webpack_public_path__ + "static/media/icon-message.223779f7.svg";